module.exports = __webpack_public_path__ + "img/pnud_loader.da596f1b.jpg";